import React, { useCallback } from 'react';
import cn from 'classnames';
import { observer } from 'store';
import { Grid, GridItem } from 'components/UI/Grid';
import Title from 'components/UI/Title';
import { DEFAULT_COLS } from '../../../constants';
import CounterDesktop from './CounterDesktop';
import CheckboxDesktop from './CheckboxDesktop';
import { useCountersHandlers } from '../../../hooks';
import { parseDataToColumns } from './utils';
import { useLang, useTrans } from 'utils/localisation';
import * as styles from './Desktop.module.scss';

function Desktop({
  calculatorID,
  items,
  counterType,
  onChangeCount,
  getCounterValue,
  cols = DEFAULT_COLS,
  sectionIndex,
}) {
  const { increment, decrement } = useCountersHandlers(onChangeCount);
  const lang = useLang();
  const t = useTrans(['calculatorHints']);
  const columns = parseDataToColumns(items, t);
  const withHintImage = lang === 'en';

  const renderCounter = useCallback(
    (name, hint, value, columnIndex, counterIndex) => {
      switch (counterType) {
        case 'counter':
          return (
            <CounterDesktop
              name={name}
              hint={hint}
              value={value}
              increment={increment}
              decrement={decrement}
              sectionIndex={sectionIndex}
              columnIndex={columnIndex}
              counterIndex={counterIndex}
            />
          );
        case 'checkbox':
          return <CheckboxDesktop name={name} hint={hint} value={value} onChange={onChangeCount} />;
        default:
          return null;
      }
    },
    [counterType],
  );

  return (
    <Grid {...cols}>
      {columns.map((item, columnIndex) => (
        <GridItem
          key={columnIndex}
          className={cn(styles.group, withHintImage && styles.withHintImage)}
        >
          <Title tag="p" size="md" className={styles.groupTitle}>
            {item.groupTitle}
          </Title>
          {item.items.map((box, counterIndex) => {
            const value = getCounterValue(box.name);

            return (
              <div className={styles.counter} key={box.name}>
                {renderCounter(box.name, box.hint, value, columnIndex, counterIndex)}
              </div>
            );
          })}
        </GridItem>
      ))}
    </Grid>
  );
}

export default observer(Desktop);
